import Vue from 'vue';
import { InvoiceStatus } from '@/enums/invoiceStatusEnum';
import InvoiceWeekProviders from './Providers/InvoiceWeekProviders';

export default Vue.component('invoice-week-item', {
  name: 'InvoiceWeekItem',
  components: {
    InvoiceWeekProviders
  },
  props: {
    'invoice': { type: Object, required: true },
    'invoiceStartDate': {type: Date, required: true}
  },
  data () {
    return {
      isEditing: false
    };
  },
  computed: {
    classObject (): any {
      let cssClass = 'color-yellow';
      if (this.invoice) {
        switch ((this.invoice as any).invoiceStatusId) {
          case InvoiceStatus.CREATED:
            cssClass = 'color-red';
            break;
          case InvoiceStatus.SUBMITTED:
            cssClass = 'color-yellow';
            break;
          case InvoiceStatus.IN_REVISION:
            cssClass = 'color-red';
            break;
          case InvoiceStatus.REVISED:
            cssClass = 'color-red';
            break;
          case InvoiceStatus.PARTIALLY_PAID:
            cssClass = 'color-yellow';
            break;
          case InvoiceStatus.FULLY_PAID:
            cssClass = 'color-green';
            break;
          default:
            cssClass = 'color-yellow';
            break;
        }
      }
      return cssClass;
    },
    isPotential (): boolean {
      const invoiceId = this.invoice.invoiceId;
      return !(invoiceId && Number(invoiceId) > 0);
    },
    personColor (): any {
      return {
        'color-yellow': this.isPotential || !this.invoice.fullyPaid,
        'color-green': this.invoice.fullyPaid
      };
    }
  },
  methods: {
    showProviders () {
      if (this.invoice.totalPayable > 0) {
        this.isEditing = !this.isEditing;
      } else {
        this.isEditing = false;
      }
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    },
    browseToFacility () {
      if (this.invoice.invoiceWeeks.length === 1){
        window.open("/facilities/" + this.invoice.facilityId + "/specialties/" + this.invoice.invoiceWeeks[0].specialtyId, '_blank');
      } else {
        window.open("/facilities/" + this.invoice.facilityId, '_blank');
      }
    },
    browseToInvoice () {
      window.open("/invoices/" + this.invoice.invoiceId, '_blank');
    },
    browseToPotentialInvoice () {
      if (this.invoice.mergedInvoiceId) {
        window.open("/invoices/merged/" + this.invoice.mergedInvoiceId, '_blank');
      } else {
        const date = new Date(this.invoiceStartDate);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const invoiceDate = date.getFullYear() + '-' + month + '-' + day;
        window.open("/facilities/" + this.invoice.facilityId + "/specialties/" + this.invoice.invoiceWeeks[0].specialtyId + '/invoices/date/' + invoiceDate, '_blank');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoices/components/InvoiceWeekItem.ts